import { useEffect } from 'react';

const useTextAreaAutoResize = ({ textAreaElRef }) => {
    useEffect(() => {
        const { current: textAreaEl } = textAreaElRef;
        if (!textAreaEl) {
            return undefined;
        }
        const onTextAreaInput = () => {
            textAreaEl.style.setProperty('height', 'auto');
            const { requestAnimationFrame, cancelAnimationFrame } = window;
            const animReuestId = requestAnimationFrame(() => {
                const { scrollHeight } = textAreaEl;
                const { borderWidth } = window.getComputedStyle(textAreaEl);
                const textAreaElHeight = (scrollHeight + Number.parseInt(borderWidth, 10));
                textAreaEl.style.setProperty('height', `${textAreaElHeight}px`);
                cancelAnimationFrame(animReuestId);
            });
        };
        textAreaEl.addEventListener('input', onTextAreaInput);
        return () => {
            textAreaEl.removeEventListener('input', onTextAreaInput);
        };
    }, [textAreaElRef]);
};

export { useTextAreaAutoResize as u };
//# sourceMappingURL=hook-CqTFdMVw.js.map
